<template>
  <div class="project-summary">
    <div class="space-x-2 select-none">
      <template v-if="project">
        <PBadge v-if="project.isActive === false" color="warning" size="sm">Inactief</PBadge>
        <span class="space-x-1 text-sm font-medium">
          <ModelEditLink v-if="enableModelLinks" :model="project">
            {{ getProjectDisplayName(project) }}
          </ModelEditLink>
          <span v-else>{{ getProjectDisplayName(project) }}</span>
        </span>

        <span v-if="project.executor?.person" class="space-x-1 text-sm font-medium">
          <FontAwesomeIcon icon="coins" size="xs" title="Financieel verantwoordelijke" />
          <ModelEditLink v-if="enableModelLinks" :model="project.executor.person">
            {{ project.executor.person.fullName }}
          </ModelEditLink>
          <span v-else>{{ project.executor.person.fullName }}</span>
        </span>

        <span
          v-if="project.executor?.knownBusinessEntityName"
          class="space-x-1 text-sm font-medium"
        >
          <FontAwesomeIcon icon="building" size="xs" title="Bedrijf" />
          <ModelEditLink
            v-if="enableModelLinks && project.executor.knownBusinessEntity"
            :model="project.executor.knownBusinessEntity"
          >
            {{ project.executor.knownBusinessEntityName }}
          </ModelEditLink>
          <span v-else>{{ project.executor.knownBusinessEntityName }}</span>
        </span>
      </template>
      <template v-else>
        <span class="text-sm font-medium">&lt;project invoeren&gt;</span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getProjectDisplayName } from "@/helper/models/project-display-helper"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import ModelEditLink from "@/components/misc/ModelEditLink.vue"
import PBadge from "@/components/elements/PBadge.vue"
import type { Project } from "@/models/project.model"

withDefaults(
  defineProps<{
    project?: Project | null
    enableModelLinks?: boolean
  }>(),
  {
    enableModelLinks: false
  }
)
</script>
